const moment = require("moment");

const getToken = () => {
    return sessionStorage.getItem('token') || localStorage.getItem('token') || null;
}

const getUserDetail = () => {
    return JSON.parse(sessionStorage.getItem('user_detail')) || JSON.parse(localStorage.getItem('user_detail')) || null;
}

const getUserType = () => {
    if(sessionStorage.getItem('user_detail')){
        return JSON.parse(sessionStorage.getItem('user_detail'))['type'];
    }else if (localStorage.getItem('user_detail')) {
        return JSON.parse(localStorage.getItem('user_detail'))['type'];
    } else {
        return 0;
    }
}

const removeUserSession = () => {
    if(sessionStorage.getItem('user_detail')){
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user_detail');
    }else{
        localStorage.removeItem('token');
        localStorage.removeItem('user_detail');
    }
}

const setUserSession = (token, user, setSession = false) => {
    if(setSession){
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user_detail', JSON.stringify(user));
    }else{
        localStorage.setItem('token', token);
        localStorage.setItem('user_detail', JSON.stringify(user));
    }
}

const setUserDetail = (user) => {
    localStorage.setItem('user_detail', JSON.stringify(user));
}

const is_login = () => {
    if (sessionStorage.getItem('token') || localStorage.getItem('token')) {
        return true;
    } else {
        return false;
    }
}

const amountFormatUse = (amount) => {
    if (amount) {
        return '₹ ' + parseFloat(amount).toFixed(2);
    } else {
        return '₹ ' + parseFloat(0).toFixed(2);
    }
}
const amountFormat = (amount) => {
    if (amount) {
        return parseFloat(amount).toFixed(2);
    } else {
        return parseFloat(0).toFixed(2);
    }
}

const img_view = (img, width = '', height = '', auto = true) => {
    return process.env.REACT_APP_IMG_URL + 'uploads/' + img
    // if (auto) {
    //     return process.env.REACT_APP_IMG_URL + 'img?img=' + img + '&w=' + width + '&h=' + height
    // } else {
    //     return process.env.REACT_APP_IMG_URL + 'uploads/' + img
    // }
}
const Date_format = (date) => {
    var new_date = new Date(date),
        mnth = ("0" + (new_date.getMonth() + 1)).slice(-2),
        day = ("0" + new_date.getDate()).slice(-2);
    return [new_date.getFullYear(), mnth, day].join("-");
}


const IsModemAccess = (modem_name, type) => {
    if(getUserDetail()){
        var modem = getUserDetail()?.['roleAssigned'];
        if (modem && modem[modem_name] && modem[modem_name].module[type] === 1) {
            return true;
        } else {
            return false;
        }
    }else{
        return false;
    }
}

const utc_local = (data_time, format = "DD/MM/YYYY HH:mm:ss") => {
    if (data_time) {
        var timeDifference = null;
        if (timeDifference != null && (timeDifference >= 0 || timeDifference < 0)) {
            return moment.utc((new Date(data_time).getTime() + (parseInt(timeDifference) * 1000))).format(format);
        } else {
            return moment.utc(data_time).local().format(format);
        }
    } else {
        return '';
    }
}

const setDefaultLocale = (locale) => {
    localStorage.setItem('locale', locale);
}

const getDefaultLocale = (locale) => {
    return localStorage.getItem('locale') || 'en';
}



export { setDefaultLocale, getDefaultLocale, utc_local, IsModemAccess, amountFormatUse, Date_format, img_view, amountFormat, getUserType, getToken, removeUserSession, setUserSession, is_login, getUserDetail, setUserDetail };